import { useOutletContext } from 'react-router-dom'

import { GroupsDataCollection } from 'modules/expenses/components/groups/DataCollection'
import { GroupsDataTable } from 'modules/expenses/components/groups/DataTable'
import { TabRouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { useMyExpenses } from 'modules/expenses/pages/my_expenses/MyExpensesContext'

const MyGroupsListTab = () => {
  const { employeeIds } = useOutletContext<TabRouteContextParams>()
  const {
    featureAvailabilities: { dataCollectionEnabled },
  } = useMyExpenses()

  return dataCollectionEnabled ? (
    <GroupsDataCollection employeeIds={employeeIds} />
  ) : (
    <GroupsDataTable employeeIds={employeeIds} />
  )
}

export default MyGroupsListTab
